<template>
    <!-- Modal -->
    <div aria-hidden="true" aria-labelledby="exampleModalLabel" class="modal fade" id="typeModal"
         role="dialog" tabindex="-1">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Modal title</h5>
                    <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <type-create></type-create>
            </div>
        </div>
    </div>
</template>
<script>
    import TypeCreate from "@/views/componenttype/Form.vue"

    export default {
        components: {
            TypeCreate
        }
    }
</script>
